import React from "react";

import Aside from "../../components/Aside/Aside";

interface JuricalProps {}

const JuricalPage: React.FC<JuricalProps> = () => {
  return (
    <div
      data-v-dde546dc=""
      className="el-container app__container app__content"
    >
      <Aside isJurical={1}/>
      <div style={{ width: "100%" }}>
        <main data-v-dde546dc="" className="el-main">
          <div data-v-0c054ff4="" data-v-dde546dc="" className="profile">
            <h1 data-v-0c054ff4="">Тарифы</h1>
            <div data-v-0c054ff4="">
              <div className="profile__cards">
                <div className="el-col el-col-24">
                  <h1 style={{ textAlign: "center" }}>
                    Для смены тарифного плана обратитьсь к вашему менеджеру по
                    <span className="red bold">
                      <u> e-mail manager@lansat.ru</u>
                    </span>
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default JuricalPage;
